import './JobStartModal.scss';
import { useTranslator } from '@Localization';
import { noop } from 'lodash';
import { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Loader } from '../../../__legacy__/components/Loader';
import { S_ConfirmationModal } from '../../../design/modals/confirmationModal/S_ConfirmationModal';
import { JOB_STATUS, JOB_TYPE } from '../jobs.model';
import { getJobTranslationPrefix } from '../utils';

export const START_MODAL_LOADER_KEY = 'start-modal-loader';

export enum JOB_START_MODAL_TYPE {
  START = 'START',
  RESTART = 'RESTART',
}

interface JobStartModalProps {
  jobType: JOB_TYPE;
  status: JOB_STATUS;
  type: JOB_START_MODAL_TYPE;
  isOpen: boolean;
  toggle: () => void;
  onSubmit: () => Promise<void>;
  isLoading: boolean;
  isOverlayVisible?: boolean;
  estimatedCost: number | null;
  availableFunds: number;
}

export const JobStartModal = ({
  jobType,
  status,
  type,
  isOpen,
  toggle,
  onSubmit,
  isLoading,
  estimatedCost,
  availableFunds,
  isOverlayVisible = false,
}: JobStartModalProps): ReactNode => {
  const { t } = useTranslator();
  const translationPrefix = getJobTranslationPrefix(jobType);
  const isStartSubmitDisabled = estimatedCost && availableFunds ? estimatedCost > availableFunds : true;

  return (
    <S_ConfirmationModal
      className='job-start-modal'
      isOpen={isOpen}
      headerText={t('cost_estimation.header', {
        action: type === JOB_START_MODAL_TYPE.RESTART ? t(`${translationPrefix}.restart.text`) : t(`${translationPrefix}.start.text`),
      })}
      submitText={t('confirm')}
      cancelText={t('cancel')}
      onCancel={!isLoading ? toggle : noop}
      toggle={toggle}
      onSubmit={onSubmit}
      disableSubmitButton={isStartSubmitDisabled}
      isLoading={isLoading}
      loaderKey={START_MODAL_LOADER_KEY}
    >
      {isOverlayVisible && <Loader isLoading={true} />}
      <>
        {status === JOB_STATUS.STOPPED && JOB_START_MODAL_TYPE.RESTART && <p>{t(`${translationPrefix}.restart.info`)}</p>}
        <p>
          <Trans
            i18nKey={isStartSubmitDisabled ? 'cost_estimation.error' : 'cost_estimation.info'}
            values={{ costEstimated: Math.ceil((estimatedCost ?? 0) * 100), availableFunds: Math.floor(availableFunds * 100) }}
            components={{ b: <b /> }}
          />
        </p>
      </>
    </S_ConfirmationModal>
  );
};
